export default {"src":"/_next/static/media/0x818ec0a7fe18ff94269904fced6ae3dae6d6dc0b.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};